<script lang="ts">
	import ReviewStar, { type Props as ReviewStarProps } from '$lib/icons/reviewStar.svelte';

	interface Props {
		totalStars?: number;
		score?: number;
		starClass?: string;
		theme?: ReviewStarProps['theme'];
	}

	let { totalStars = 5, score = 5.0, starClass = 'w-6 h-6', theme = 'yellow' }: Props = $props();

	let fullStars = $derived(Math.floor(score));
	let lastStarPercentage = $derived(score - fullStars);
</script>

<div class="flex justify-center gap-x-1">
	{#each Array(fullStars) as _}
		<ReviewStar {theme} fillPercentage={1} class={starClass} />
	{/each}
	{#if totalStars - fullStars > 0}
		<ReviewStar {theme} fillPercentage={lastStarPercentage} class={starClass} />
		{#each Array(totalStars - fullStars - 1) as _}
			<ReviewStar {theme} fillPercentage={0} class={starClass} />
		{/each}
	{/if}
</div>
